import { isNil } from 'lodash'
import { pathApi, usedUrl } from './basepath'

// const localApi = 'http://localhost:8000'
// const pathApi = 'http://localhost:8889'
const pathApiAqua6bo ='https://aqua6bo.aquadb.fr/services'
const usedUrlFormatted = `${usedUrl}${usedUrl.endsWith('/') ? '' : '/'}`

export default {
    auth: {
        logout: () => `${pathApi}/logout`,
        loginWithDiscord: (code) => `${pathApi}/loginWithDiscord?code=${code}`,
        user: (login) => `${pathApi}/user/${login}`,
        users: () => `${pathApi}/user`,
    },
    dashboard: () => `${pathApi}/supervision/dashboard`,
    dashboardInstances: () => `${pathApi}/supervision/dashboard/instances`,
    jobErrorLogs: () => `${pathApi}/supervision/job/errorLogs`,
    pingState: () => `${pathApi}/supervision/pingState`,
    testHeaders: () => `${pathApi}/supervision/testHeaders`,
    dataBanks: () => `${pathApi}/supervision/dataBanks`,
    instance: {
        all: () => `${pathApi}/supervision/instance`,
        parameters: () => `${pathApi}/supervision/instance/parameters`,
        single: id => `${pathApi}/supervision/instance/${id}`,
    },
    service: {
        all: () => `${pathApi}/supervision/service`,
        single: id => `${pathApi}/supervision/service/${id}`,
    },
    supervision: {
        types: () => `${pathApi}/supervision/stats/types`,
        statsByTypes: (type) => `${pathApi}/supervision/stats/byType/${type}`,
        uptimeSla: () => `${pathApi}/supervision/stats/uptimeSla`,
        fail2banStat: () => `${pathApi}/fail2ban/stat`,
        fail2banDetail: (year, month) => `${pathApi}/fail2ban/stat/detail/${year}/${month}`,
    },
    timeError: {
        dashboard: () => `${pathApi}/supervision/timeErrors/dashboard`,
        list: () => `${pathApi}/supervision/timeErrors/list`,
    },
    agenda: {
        events: () => `${pathApi}/supervision/calendar/events`,
    },
    gdl: {
        adminFeatures: () => `${pathApi}/GDL/featureAdmin`,
        adminFeature: (id) => `${pathApi}/GDL/featureAdmin/${id}`,
        customers: () => `${pathApi}/GDL/customer`,
        customer: id => `${pathApi}/GDL/customer/${id}`,
        customerNotes: idClient => `${pathApi}/GDL/customerNotes/${idClient}`,
        contacts: () => `${pathApi}/GDL/contact`,
        contact: id => `${pathApi}/GDL/contact/${id}`,
        allLots: () => `${pathApi}/GDL/lots`,
        lots: idClient => `${pathApi}/GDL/lots/${idClient}`,
        lot: () => `${pathApi}/GDL/lot`,
        lotById: id => `${pathApi}/GDL/lot/${id}`,
        lotNote: () => `${pathApi}/GDL/lot/note`,
        lotNoteById: id => `${pathApi}/GDL/lot/note/${id}`,
        notes: () => `${pathApi}/GDL/note`,
        note: id => `${pathApi}/GDL/note/${id}`,
        globalNote: () => `${pathApi}/GDL/globalNote`,
        globalNoteHistory: () => `${pathApi}/GDL/globalNote/history`,
        subjects: () => `${pathApi}/GDL/roadmap/subject`,
        subject: id => `${pathApi}/GDL/roadmap/subject/${id}`,
        priorites: () => `${pathApi}/GDL/priorites`,
        priorite: () => `${pathApi}/GDL/priorite`,
        prioriteById: id => `${pathApi}/GDL/priorite/${id}`,
        prioriteSujet: () => `${pathApi}/GDL/priorite/sujet`,
        prioriteSujetById: id => `${pathApi}/GDL/priorite/sujet/${id}`,
        customerStats: () => `${pathApi}/GDL/customerStats`,
        customerLicenses: id => `${pathApi}/GDL/licence?customerId=${id}`,
        licenses: () => `${pathApi}/GDL/licence`,
        licensesSynthesis: (customerId) => `${pathApi}/GDL/licencesSyntesis/${customerId}`,
        license: id => `${pathApi}/GDL/licence/${id}`,
        activeUsers: () => `${pathApi}/GDL/activeUsers`,
    },
    jenkins: {
        launchJob: (job) => `${usedUrlFormatted}jenkins/job/${job}/build`,
    },
    commercialFeatures: {
        admins: () => `${pathApi}/GDL/commercialFeature/admin`,
        admin: (id) => `${pathApi}/GDL/commercialFeature/admin/${id}`,
        product: (idOpt) => `${pathApi}/GDL/product${isNil(idOpt) ? '' : `?id=${idOpt}`}`,
        getLinkAdminFeatures: (id) => `${pathApi}/GDL/commercialFeature/linkFeatureAdmin${isNil(id) ? '' : `?idCommercialFeature=${id}`}`,
        linkAdminFeatures: id => `${pathApi}/GDL/commercialFeature/linkFeatureAdmin/${id}`,
    },
    support: {
        createIssues: () => `${pathApi}/support/issues`,
        updateIssues: () => `${pathApi}/support/editIssues`,
        statisticsResolved: () => `${pathApi}/support/stats/resolved`,
        statisticsCreated: () => `${pathApi}/support/stats/created`,
        statisticsGraph: () => `${pathApi}/support/stats/graph`,
        statisticsEvolution: () => `${pathApi}/support/stats/evolution`,
        statisticsIncidents: () => `${pathApi}/support/stats/incidents`,
        statisticsStock: () => `${pathApi}/support/stats/stock`,
        statisticsLots: () => `${pathApi}/support/stats/lots`,
        statisticsRecette: () => `${pathApi}/support/stats/recette`,
        projects: () => `${pathApi}/support/projects`,
        tags: () => `${pathApi}/support/tags`,
        issuesNotCovered: () => `${pathApi}/support/issues/notCovered`,
        issuesUnansweredClient: () => `${pathApi}/support/issues/unanswered/client`,
        issuesUnansweredSupport: () => `${pathApi}/support/issues/unanswered/support`,
        recette: () => `${pathApi}/support/issues/recette`,
        internValidation: () => `${pathApi}/support/issues/internValidation`,
        attenteValidationCount: () => `${pathApi}/support/issues/attenteValidation/count`,
        recetteIaeau: () => `${pathApi}/support/issues/recette/iaeau`,
        internValidationIaeau: () => `${pathApi}/support/issues/internValidation/iaeau`,
        attenteValidationCountIaeau: () => `${pathApi}/support/issues/attenteValidation/count/iaeau`,
        issuesMEIIaeau: () => `${pathApi}/support/issues/mei/iaeau`,
        endRecetteIaeau: () => `${pathApi}/support/issues/endRecette/iaeau`,
        versions: () => `${pathApi}/support/issues/versions`,
        addNote: () => `${pathApi}/support/issues/addNote`,
        issuesMEI: () => `${pathApi}/support/issues/mei`,
        endRecette: () => `${pathApi}/support/issues/endRecette`,
    },
    devLot: {
        all: () => `${pathApi}/devlot/lots`,
        lot: () => `${pathApi}/devlot/lot`,
        lotById: id => `${pathApi}/devlot/lot/${id}`,
        assign: () => `${pathApi}/devlot/assign`,
        assignByTicket: idTicket => `${pathApi}/devlot/assign/${idTicket}`,
    },
    aqua6Bo: {
        export: () => `${pathApiAqua6bo}/export/`,
    },
    uptime: {
        heartbeat: () => `${pathApi}/uptime/heartbeat`,
    },
}
